import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { BreadcrumbService } from '../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,

  selector: 'vs-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  constructor(
    private breadcrumbService: BreadcrumbService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.setShowHideBreadcrumb(false)
  }

  ngOnDestroy(): void {
    this.breadcrumbService.setShowHideBreadcrumb(true)
  }

  redirectToHomepage() {
    this.router.navigate(['/home'])
  }
}
